import { Route, Routes } from "react-router-dom";
import "./App.css";
import Navbar from "./components/Shared/Navbar";
import Home from "./pages/Home";
import AboutUs from "./pages/About";
import Prediabetes from "./pages/Pre-diabetes";
import Login from "./components/Auth/Login";
import AbdominalObesity from "./pages/Abdominal-Obesity";
import Unhealthy from "./pages/Unhealthy";
import "@fortawesome/fontawesome-free/css/all.min.css";
import Shop from "./pages/Shop";
import RiskofHeart from "./pages/Risk-Heart-Disease";
// import Knowyourcarb from "./pages/Reducarb-Blends";
// import Resources from "./pages/Calculator";
import ScrollToTop from "./components/Shared/ScrollTop";
import UserDashboard from "./pages/UserDashboard";
import ReducarbBenefits from "./pages/Reducarb-Benefits";
import FAQSection from "./pages/Faq";
import ReadyReckoner from "./pages/ReadyReckoner";
import Press from "./pages/Press";
import Calculator from "./pages/Calculator";
// import KnowyourCarb from "./components/Shared/Knowyourcarbcontent";
import Privacy from "./pages/Privacy";
import Terms from "./pages/Terms";
import ReducarbBlends from "./pages/Reducarb-Blends";
import ReducarbVariants from "./pages/reducarb-variants";
import Cart from "./pages/Cart";
import { UserProvider } from "./api/AuthContext";
import User_Profile from "./components/User/user-profile";
import User_orders from "./components/User/user-orders";
import User_Assessments from "./components/User/Assessment";
import ParentAssessments from "./components/User/ParentAssessments";
import ConsultationAppointment from "./components/User/user-consultations";
import User_Appointment from "./components/User/user-appointment";
import ViewResults from "./components/User/ViewResults";
import ProductDetails from './pages/ProductDetail';
import AppointmentConfirmation from "./pages/AppointmentConfirmation";
import Signup from "./components/Auth/Signup";
import Checkout from "./pages/Checkout";
import BingeEating from "./components/Deprecated/Assessment/BingeEating";
import MedicalSubAssessment from "./components/User/Assessments/MedicalSubAssessments";
import { Navigate } from "react-router-dom";
import StartAssessment from './components/User/StartAssessment';
import ViewResponses from './components/User/ViewResponses';
import StartMedicalAssessment from './components/User/Assessments/StartMedicalAssessment';
import ViewMedicalResponses from "./components/User/Assessments/ViewMedicalResponses";
import ForgotPassword from "./components/Auth/ForgotPassword";
import ResetPassword from "./components/Auth/ResetPassword";
import ContactUs from "./pages/ContactUs";
import PaymentSuccess from "./pages/payment-success";
import PaymentResponse from './components/Payment/PaymentResponse';

function App() {
  
  return (
    <UserProvider>
      <div>
        <Navbar />
      </div>

      <div>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/index" element={<Home />} />
          <Route path="/about" element={<AboutUs />} />
          <Route path="/pre-diabetes" element={<Prediabetes />} />
          <Route path="/login" element={<Login />} />
          <Route path="/abdominal-obesity" element={<AbdominalObesity />} />
          <Route path="/unhealthy" element={<Unhealthy />} />
          <Route path="/risk-heart-disease" element={<RiskofHeart />} />
          <Route
            path="/reducarb-blends/:blendName"
            element={<ReducarbBlends />}
          />
          <Route
            path="/reducarb-variants/:blendName"
            element={<ReducarbVariants />}
          />
          <Route path="/reducarb-benefit" element={<ReducarbBenefits />} />
          <Route path="/faq" element={<FAQSection />} />
          <Route path="/ready-reckoner" element={<ReadyReckoner/>}/>
          <Route path="/press" element={<Press/>}/>
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms-and-conditions" element={<Terms />} />
          <Route path="/shop" element={<Shop />} />
          <Route path="/cart" element={<Cart />} />
          <Route path="/sign-up" element={<Signup />} />
          <Route path="/forgot-password" element={<ForgotPassword/>} />
          <Route path="/reset-password" element={<ResetPassword/>} />
          <Route path="/checkout" element={<Checkout />} />
          <Route path="/binge" element={<BingeEating/>} />
          <Route path="/product/:productId" element={<ProductDetails/>} />
          <Route path="/calculators" element={<Calculator />} />
          <Route path="contact-us" element={<ContactUs />} />
          <Route path="/appointment-confirmation" element={<AppointmentConfirmation />} />
          <Route path="/payment/payu/callback" element={<PaymentSuccess />} />
          <Route path="/payment/response" element={<PaymentResponse />} />

          <Route path="/user" element={<UserDashboard />}>
            <Route index element={<Navigate to="orders" />} />
            <Route path="profile" element={<User_Profile />} />
            <Route path="orders" element={<User_orders />} />
            <Route path="assessments" element={<ParentAssessments />} />
            <Route path="consultations" element={<ConsultationAppointment />} />
            <Route path="appointments" element={<User_Appointment />} />
            <Route path="results/:assessmentId" element={<ViewResults />} />
            <Route path="assessments/:assessmentId" element={<User_Assessments />} />
            <Route path="assessments/medical-assessment" element={<MedicalSubAssessment />} />
            <Route path="medical-assessment/start/:assessmentId" element={<StartMedicalAssessment />} />
            <Route path="medical-assessment/responses/:assessmentId" element={<ViewMedicalResponses />} />
            <Route path="assessment/start/:assessmentId" element={<StartAssessment />} />
            <Route path="assessment/responses/:assessmentId" element={<ViewResponses />} />
          </Route>


        </Routes>
      </div>
    </UserProvider>
  );
}

export default App;
